import { Button, message, Space, Table } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { serverFetch } from "@server";
import { renderCheckbox } from "@extensions/helper";
import { deleteButton } from "@extensions/design";
import TaskUser from "./task-user";

const TaskUsers = () => {
  const user = useSelector((s) => s.user);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);

  const getData = () => {
    if (!user?.companyId) return;
    setLoading(true);
    serverFetch(`plan/dep?companyId=${user.companyId}`)
      .then(data => {
        setLoading(false);
        setItems(data);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  useEffect(() => {
    if (user?.companyId) getData();
  }, [user?.companyId]);

  const onDelete = record => {
    setLoading(true);
    serverFetch(`plan/dep/${user?.companyId}/${record.id}`, { method: "DELETE" })
      .then(() => getData())
      .catch(e => message.error(e.userMessage))
      .finally(() => setLoading(false));
  };

  const onCreate = () => setSelected({ companyId: user?.companyId, id: 0, userName: "", active: true, name: "" });

  const onEdit = record => setSelected({ ...record });

  const columns = [
    { dataIndex: "id", title: "#", width: 60 },
    { dataIndex: "active", title: "Активен", width: 80, render: renderCheckbox },
    { dataIndex: "userName", title: "Телефон/почта" },
    { dataIndex: "name", title: "Наименование" },
    {
      title: "",
      render: (_, record) => (
        <div className="actions-on-hover">
          <Button type="link" size="small" onClick={() => onEdit(record)}>Изменить</Button>
          {deleteButton(loading, record.name, () => onDelete(record))}
        </div>
      ),
    },
  ];

  const onItemClose = refresh => {
    setSelected(null);
    if (refresh) getData();
  };

  return <div>
    <Space>
      <Button onClick={onCreate} type="primary">Добавить</Button>
      <Button onClick={getData} loading={loading}>Обновить</Button>
    </Space>
    <Table
      dataSource={items}
      loading={loading}
      columns={columns}
      pagination={false}
      size="small"
      rowKey="id"
    />
    {selected && <TaskUser onClose={onItemClose} itemDefault={selected} companyId={user?.companyId} />}
  </div>
};

export default TaskUsers;
